const state = {
  list: [],
  chosenList: [],
  previewCargoList: [], // 预览货品价格
  isEdit: false,
}

const getters = {
  offerBuyInfoMap (state) {
    const buyInfoMap = {}
    const list = state.list.filter(item => state.chosenList.includes(item.ctid))
    list.forEach(item => {
      if (!buyInfoMap[item.ctOfferid]) {
        buyInfoMap[item.ctOfferid] = {
          minQty: item.ctExtras.minQty,
          mixNum: item.ctExtras.mixNum, // 混批數量
          mixAmount: item.ctExtras.mixAmount, // 混批數量
          buyedMixQty: list.filter(item2 => item2.ctSeller === item.ctSeller).reduce((curr, item2) => curr + item2.ctQty, 0), // 已經混批數量
          ctQty: item.ctQty,
        }
      } else {
        buyInfoMap[item.ctOfferid].ctQty = buyInfoMap[item.ctOfferid].ctQty + item.ctQty
      }
    })
    return buyInfoMap
  },
  offerExtendsMap (state) {
    // 其他信息 批發價格等
    const infoMap = {}
    const list = state.list
    list.forEach(item => {
      if (!infoMap[item.ctOfferid]) {
        infoMap[item.ctOfferid] = {
          ctQty: item.ctQty,
          price: Number(item.ctExtras.price),
        }
      } else {
        infoMap[item.ctOfferid].ctQty = infoMap[item.ctOfferid].ctQty + item.ctQty
      }
      if (item.ctExtras.productSaleInfo && item.ctExtras.productSaleInfo.quoteType !== 1) {
        const priceRangeList = [...item.ctExtras.productSaleInfo.priceRangeList]
        // startQuantity 从大到小排序
        priceRangeList.sort((a, b) => b.startQuantity - a.startQuantity)
        const priceRange = priceRangeList.find(item2 => item2.startQuantity <= infoMap[item.ctOfferid].ctQty)
        if (priceRange) {
          infoMap[item.ctOfferid].price = Number(priceRange.price)
        }
      }
    })
    return infoMap
  },
  skuInfoExtendsMap (state, getters) {
    const list = state.list
    const skuInfoExtendsMap = {}
    list.forEach(item => {
      const previewCargoItem = state.previewCargoList.find(item2 => item2.specId === item.ctSpecid)
      let price = item.ctExtras.price
      const previewUnitPrice = previewCargoItem?.previewUnitPrice || 0
      if (item.ctSaleMode === 'ALI_MAIN' && item.ctExtras.productSaleInfo && item.ctExtras.productSaleInfo.quoteType !== 1) {
      // 現貨才有批發價格
        price = getters.offerExtendsMap[item.ctOfferid].price
      }
      skuInfoExtendsMap[item.ctid] = {
        price,
        previewUnitPrice,
        previewCargoItem,
      }
    })
    return skuInfoExtendsMap
  },
  canBuyCtids (state, getters) {
    const list = state.list
      .filter(item => state.chosenList.includes(item.ctid))
    return list.filter(item => {
      return true
    }).map(item => item.ctid)
  },
  hasKkrenFreeShipping (state, getters) {
    const list = state.list.filter(item => state.chosenList.includes(item.ctid))
    return list.some(item => item.ctExtras.kkrenFreeShipping)
  },
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
  setChosenList (state, chosenList) {
    state.chosenList = chosenList
  },
  setIsEdit (state, isEdit) {
    state.isEdit = isEdit
  },
  setPreviewCargoList (state, previewCargoList) {
    state.previewCargoList = previewCargoList
  },
}

const actions = {
  batchAdd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dgorder/cart/batch-add', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchDel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dgorder/cart/batch-del', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  updata ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dgorder/cart/updata', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dgorder/cart/search', {
      params: {
        ctPlatform: 'TAOBAO',
        ...params
      },
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      if (params.ctExc === '0') {
        commit('setList', res.data.list)
      }
      return res
    })
  },
  collected ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dgorder/cart/collected', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
